import React, { Component } from "react";
import { View } from "react-native";
import { CardButton, MainText, Box, MainTitle } from "../../components/common";
import { connect } from "react-redux";
import Modal from "react-native-modal";
import i18n from "@microdoing/shared/i18n";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import { quitSession } from "@microdoing/shared/services/login/actions";
import EndSessionLottie from "./EndSessionLottie";
import theme from "app/Theme/Theme";

class EndSessionModal extends Component {
  onExit = () => {
    this.props.triggerModal();
  };

  render() {
    const { teamRank, rank, firstName, experience } = this.props;
    return (
      <Modal
        backdropTransitionOutTiming={0}
        isVisible={this.props.isVisible}
        keyboardShouldPersistTaps
        avoidKeyboard
        useNativeDriver
        onBackdropPress={this.onExit}
      >
        <View style={styles.modal}>
          <View style={styles.topView}>
            <EndSessionLottie />
          </View>
          <View style={styles.middleView}>
            <View style={styles.titleView}>
              <MainTitle
                variant="l6-bold"
                textAlign="center"
                marginLeft="m"
                marginRight="m"
              >
                {i18n.t("end-session", { firstName })}
              </MainTitle>
            </View>
            <View
              style={styles.animatedView}
              animation={"fadeInUp"}
              delay={500}
              useNativeDriver
            >
              <Box flexDirection="row">
                <MainText
                  variant="l3-medium"
                  color="neutral.500"
                  textAlign="center"
                >
                  {i18n.t("end-session-total-action-first")}
                </MainText>
                <MainText
                  variant="l3-semibold"
                  color="neutral.500" //orange
                  textAlign="center"
                >{`${" "}${experience}${" "}${i18n.t(
                  experience === 1
                    ? "end-session-total-action-second-singular"
                    : "end-session-total-action-second",
                )}`}</MainText>
              </Box>
            </View>
            <View animation={"fadeInUp"} delay={800} useNativeDriver>
              <Box flexDirection="row">
                <MainText
                  variant="l3-medium"
                  color="neutral.500"
                  textAlign="center"
                >
                  {i18n.t("end-session-user-rank-first")}
                </MainText>
                <MainText
                  variant="l3-semibold"
                  color="neutral.500" //pink
                  textAlign="center"
                >{` ${i18n.t(
                  rank === 1
                    ? "end-session-user-rank-second-is-1"
                    : "end-session-user-rank-second",
                  {
                    rank,
                  },
                )}`}</MainText>
              </Box>
            </View>
            <View animation={"fadeInUp"} delay={1100} useNativeDriver>
              <Box flexDirection="row">
                <MainText
                  variant="l3-medium"
                  color="neutral.500"
                  textAlign="center"
                >
                  {i18n.t("end-session-team-rank-first")}
                </MainText>
                <MainText
                  variant="l3-semibold"
                  color="neutral.500" //blue 600
                  textAlign="center"
                >{` ${i18n.t(
                  teamRank === 1
                    ? "end-session-team-rank-second-is-1"
                    : "end-session-team-rank-second",
                  {
                    rank: teamRank,
                  },
                )}`}</MainText>
              </Box>
            </View>
          </View>
          <View style={styles.buttonsView}>
            <CardButton
              text={i18n.t("end-session-button")}
              onPress={this.onExit}
              buttonPropStyle={styles.button}
            />
          </View>
        </View>
      </Modal>
    );
  }
}

EndSessionModal.defaultProps = {
  multipleText: [],
};

const styles = {
  button: {
    width: "90%",
    marginTop: 20,
  },
  animatedView: {
    marginTop: 5,
  },
  topView: {
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    marginTop: 8,
    color: theme.colors["neutral.400"],
    fontSize: wp("4%"),
  },
  modal: {
    backgroundColor: theme.colors["neutral.white"],
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    padding: 15,
  },
  buttonsView: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  middleView: {
    maxHeight: hp("40%"),
  },
  titleView: {
    marginTop: 10,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginBottom: 10,
  },
};

export default connect(null, { quitSession })(EndSessionModal);
